export function safeParse(str: string, def: any = {}): any {
  try {
    return JSON.parse(str) || def;
  } catch (e) {
    return def;
  }
}

export function formatIban(iban: string): string {
  // Prepend the iban with 'BE' if it's not already there
  if (!iban.startsWith('BE')) {
    return `BE${iban}`;
  } else {
    return iban;
  }
}
